export default () => {
  return {
    content: {
      on_dashboard: true,
      layout: `dashboard`,
    },
  };
};
